import {Trans} from '@lingui/macro';
import {isEqual} from 'lodash';
import React, {FC, useMemo} from 'react';

import {getAtomDefaultParameters, getParameters} from '../../../editors/expressions/expressionInferHelpers';
import {TimePeriodsEnum} from '../../../editors/expressions/infer/dateTimeType';
import {RuleMultilineParameterCard} from '../ruleMultilineParameterCard';
import {AtomCardProps} from './atomCard';
import {AtomIcon} from './atomIcon';
import {AtomTitle} from './atomTitle';
import {StyledParameterLineDiv, StyledParameterTitleLineDiv} from './parameterLine';
import {AtomParameterPicker} from './pickers/atomParameterPicker';

export const StartOfAtomCard: FC<AtomCardProps> = (props) => {
  const {atom, isDisabled, onUpdateAtom, onCancel} = props;
  const [periodParam, timezoneParam, weekStartParam] = getParameters(atom);

  const shouldDisplayWeekStart = atom.params.period === TimePeriodsEnum.WEEK;

  // Auto-expand if params have been edited.
  const shouldExpandCollapsableParameters = !isEqual(atom.params, getAtomDefaultParameters(atom));

  const collapsableParameters = useMemo(
    () =>
      [
        <StyledParameterLineDiv key="timezone">
          <StyledParameterTitleLineDiv>
            <Trans id="rule-expressions-timezone">Time zone</Trans>
          </StyledParameterTitleLineDiv>
          <AtomParameterPicker
            parameter={timezoneParam}
            atom={atom}
            isDisabled={isDisabled}
            onUpdate={onUpdateAtom}
          />
        </StyledParameterLineDiv>,
        shouldDisplayWeekStart ? (
          <StyledParameterLineDiv key="weekStart">
            <StyledParameterTitleLineDiv>
              <Trans id="rule-expressions-weekstartson">Week starts on</Trans>
            </StyledParameterTitleLineDiv>
            <AtomParameterPicker
              parameter={weekStartParam}
              atom={atom}
              isDisabled={isDisabled}
              onUpdate={onUpdateAtom}
            />
          </StyledParameterLineDiv>
        ) : undefined,
      ].filter(Boolean),
    [timezoneParam, weekStartParam, atom, shouldDisplayWeekStart, isDisabled, onUpdateAtom],
  );

  const title = (
    <AtomTitle atom={atom}>
      <AtomParameterPicker
        parameter={periodParam}
        atom={atom}
        onUpdate={onUpdateAtom}
        isDisabled={isDisabled}
      />
    </AtomTitle>
  );

  return (
    <RuleMultilineParameterCard
      errorMessage={atom.errorMessage}
      icon={<AtomIcon atom={atom} />}
      title={title}
      onCancel={onCancel}
      collapsableParameters={collapsableParameters}
      shouldExpandCollapsableParameters={shouldExpandCollapsableParameters}
    />
  );
};
